"use strict";

angular.module("core")
.component("checkboxAll", {
    templateUrl: require("./checkbox-all.component.html"),
    controller: CheckboxAllController,
    controllerAs: "checkboxAllCtrl",
    bindings: {
        model: "=",
        selectedCount: "=",
        totalCount: "=",
        listObject: "=",
        updateFunction: "&?"
    }
});
require("core/indeterminate/indeterminate.directive.js");

function CheckboxAllController() {
    var _this = this;

    this.isIndeterminate = function() {
        return _this.model && _this.selectedCount != _this.totalCount;
    };

    this.selectAll = function() {
        var selected = _this.model;
        angular.forEach(_this.listObject, function(value, key) {
            value.selected = selected;
        });
        if (_this.updateFunction) {
            _this.updateFunction({selected: selected});
        }
    };
}



//////////////////
// WEBPACK FOOTER
// ./core/checkbox-all/checkbox-all.component.js
// module id = 606
// module chunks = 0